import { FC, useRef } from 'react';

import { CheckCircleOutlined } from '@ant-design/icons';
import { List, Space } from 'antd';

import { useMediaQuery } from '../vendor/ui';

import { DEVICE_SIZES } from '../constants/common';

import { Footer } from './footer';
import { PriceBlock } from './price-block';
import { SupportBlock } from './support-block';
import { TitleBlock } from './title-block';

import { LandingDivider, LandingSubtitle, Wrapper } from './styled';

type TProps = {};

export const PageInfoAplocast: FC<TProps> = () => {
  const isMobile = useMediaQuery(`(max-width: ${DEVICE_SIZES.tablet})`);
  const priceBlockRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    priceBlockRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <Wrapper>
      <TitleBlock isMobile={isMobile} scrollToBottom={scrollToBottom} />

      <LandingDivider />

      <LandingSubtitle>
        Программное обеспечение «AploCast» обеспечивает выполнение следующих
        функциональных возможностей:
      </LandingSubtitle>

      <List
        size='large'
        bordered
        dataSource={[
          'Воспроизведение видео- и графических файлов на устройствах Android',
          'Формирование и управление плейлистами воспроизведения',
          'Поддержка серверных и локальных плейлистов',
          'Синхронизация контента и настроек с сервером',
          'Автономное воспроизведение контента при отсутствии интернет-соединения',
          'Автоматическая синхронизация данных при восстановлении соединения',
          'Управление порядком воспроизведения контента',
          'Обновление контента без физического доступа к устройству',
          'Поддержка непрерывного воспроизведения в режиме 24/7',
          'Централизованное управление несколькими устройствами',
        ]}
        renderItem={(item, index) => (
          <List.Item key={index} style={{ fontSize: '16px' }}>
            <Space>
              <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
              <span>
                {index + 1}. {item}
              </span>
            </Space>
          </List.Item>
        )}
      />

      <LandingDivider />

      <PriceBlock />

      <SupportBlock />

      <Footer />
    </Wrapper>
  );
};
